import { GET_AGENT_LEAVE_BALANCE } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';

export interface LeaveBalance {
  [leaveType: string]: { available: number };
}

const getAgentLeaveBalance = async (
  email: string,
  account: string
): Promise<{ success: boolean; data?: { balance: LeaveBalance }; message?: string }> => {
  const response = await makeAuthenticatedRequest(
    GET_AGENT_LEAVE_BALANCE(email, account),
    { method: 'GET', headers: { 'Content-Type': 'application/json' } }
  );

  if (!response.ok) {
    throw new Error(`Failed to fetch leave balance: ${response.statusText}`);
  }

  const result = await response.json();
  if (!result.success) throw new Error(result.message);
  return result;
};

export const agentLeaveBalanceQueryKey = (email: string, account: string) => [
  'agent-leave-balance',
  email,
  account,
];

export { getAgentLeaveBalance };
